import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import CrossedCircle from '@factorialco/f0-react/icons/app/CrossedCircle'
import type { EmployeePayrollRunElementInputEmployeePayrollRunCompensationFragment } from 'generated/resources/graphql'

import { useSyncStateTranslations } from 'modules/integrations/hooks/useSyncStateTranslations'

import './index.styles.css'

type IntegrationsSyncableErrorMessages = NonNullable<
  EmployeePayrollRunElementInputEmployeePayrollRunCompensationFragment['syncableState']
>[number]['errorMessages'][number]

interface FailedLabelProps {
  errorMessages: Array<IntegrationsSyncableErrorMessages>
}

export const FailedLabel = ({ errorMessages }: FailedLabelProps) => {
  const translations = useSyncStateTranslations()
  const formattedErrorMessage = errorMessages
    .map((error) => error.value)
    .filter(Boolean)
    .join(', ')

  return (
    <Box flexDirection="row" gap="s2" justifyContent="flexEnd" alignItems="center">
      <Text.Normal color="radicalRed800" size="100">
        <F0Icon icon={CrossedCircle} type="warning" />
      </Text.Normal>
      <Text.Normal color="radicalRed1500" size="100" className="SyncStateLabel_labelMargin">
        {formattedErrorMessage
          ? `${translations.failed}. ${formattedErrorMessage}`
          : translations.failed}
      </Text.Normal>
    </Box>
  )
}
